import { z } from 'zod'
import { workflowNodeSchema, workflowEdgeSchema } from './workflow'

export const WORKFLOW_SCHEMA_VERSION = 'archon.workflow/v1' as const

/**
 * Zod schema mirroring backend `WorkflowExport` (see `backend/app/schemas/workflow_export.py`
 * and 03-02-export-import-backend-SUMMARY.md, decisions D-06/D-07).
 *
 * Matches backend `extra="forbid"` via `.strict()` — unknown top-level keys are rejected.
 */
export const workflowExportSchema = z
  .object({
    schema_version: z.literal(WORKFLOW_SCHEMA_VERSION),
    name: z.string().min(1).max(255),
    description: z.string().nullable().optional(),
    pattern_type: z.string(),
    nodes: z.array(workflowNodeSchema).default([]),
    edges: z.array(workflowEdgeSchema).default([]),
    input_schema: z.record(z.unknown()).default({}),
    output_schema: z.record(z.unknown()).default({}),
    settings: z.record(z.unknown()).default({}),
  })
  .strict()

export type WorkflowExport = z.infer<typeof workflowExportSchema>
